import { Network } from 'components/OAuth';

// Event naming for Consumer events
// The values in this file relate to the information indicated in
// https://docs.google.com/spreadsheets/d/138hZX-EtjCli2vG0lYhcbfHvvbFZRJM7e60c0ouaUog/edit?usp=sharing

// Event 'category'
export const CATEGORY_NAV = 'Navigation';
export const CATEGORY_GLOBAL_NAV = 'Global nav';
export const CATEGORY_BUSINESS_PAGE = 'Business page';
export const CATEGORY_CITYWIDE_SEARCH = 'Citywide search';
export const CATEGORY_CLEAR_PARTNERSHIP = 'CLEAR partnership';
export const CATEGORY_WIDGET_GRID = 'Widget Grid';
export const CATEGORY_WIDGET_CAROUSEL = 'Widget Carousel';
export const CATEGORY_WINERY_PAGE = 'Winery page';
export const CATEGORY_WIDGET_BUSINESS_CARD = 'Widget Business Card';
export const CATEGORY_WIDGET_EXPERIENCE_CARD = 'Widget Experience Card';
export const CATEGORY_PROFILE = 'Profile';
export const CATEGORY_CHECKOUT = 'Checkout';

// Nav actions
export const ACTION_MOBILE_NAV_HEADER = 'Navigation mobile header action triggered';
export const ACTION_MOBILE_NAV_MENU = 'Navigation mobile menu action triggered';
export const ACTION_MOBILE_NAV_MENU_DESTINATION = 'Navigation mobile menu link clicked';
export const ACTION_DESKTOP_NAV_HEADER = 'Navigation desktop header action triggered';
export const ACTION_DESKTOP_NAV_MENU = 'Navigation desktop menu action triggered';
export const ACTION_DESKTOP_NAV_MENU_DESTINATION = 'Navigation desktop menu link clicked';
export const ACTION_DESKTOP_NAV_RESERVATION_TYPE_MENU_DESTINATION =
  'Reservation type menu link clicked';

// Widget actions
export const ACTION_SEARCH_FILTERS_OPENED = 'Search filters dialog opened';
export const ACTION_WIDGET_SHOW_MORE = 'Show more clicked';
export const ACTION_WIDGET_SEE_MORE = 'See more clicked';
export const ACTION_CARD_CLICKED = 'Card clicked';

// Business page actions
export const ACTION_BUSINESS_AVAILABILITY_SEARCH = 'Business availability search clicked';
export const ACTION_BUSINESS_SEARCH_RESULT_CLICKED = 'Business search result clicked';
export const ACTION_BUSINESS_EXPERIENCE_SEARCH_RESULT_CLICKED =
  'Business experience search result clicked';
export const ACTION_BUSINESS_OFFERING_CLICKED = 'Business offering clicked';
export const ACTION_BUSINESS_IMAGE_CLICKED = 'Business image clicked';
export const ACTION_IMAGE_LIST_BUTTON_CLICKED = 'Business image list button clicked';
export const ACTION_VIEW_MENU = 'Menu clicked';
export const ACTION_OUTBOUND_CLICK = 'Outbound link clicked'; // safety measures

// Search actions
export const ACTION_CUISINE_FILTER_APPLIED = 'Cuisine filter applied';
export const ACTION_UNIQUE_EXP_FILTER_APPLIED = 'Unique experiences filter applied';
export const ACTION_PRICE_FILTER_APPLIED = 'Price filter applied';
export const ACTION_OFFERING_TYPE_FILTER_APPLIED = 'Offering type filter applied';

// Profile actions
export const ACTION_OPEN_ACHIEVEMENTS = 'Achievement bar item clicked';

// Login actions
export const ACTION_LOGIN = 'Login';
export const ACTION_SIGNUP = 'Signup';

// Checkout actions
export const ACTION_CHANGE_UPDATES_SUBSCRIBE = 'News and updates subscription changed';

type UserPropertyShopOrders = { property: 'Total shop orders'; value: number };
type UserPropertyShopOrderedItems = { property: 'Total shop items ordered'; value: number };
type UserPropertyShopCentsSpent = { property: 'Total shop spent cents'; value: number };

type UserPropertyReservations = { property: 'Total reservations'; value: number };
type UserPropertyReservationsCentsSpent = {
  property: 'Total reservation cents spent';
  value: number;
};

type UserPropertyShippingState = { property: 'Shop shipping state'; value: string };
type UserPropertyMetroArea = { property: 'Metro area'; value: string };
type UserPropertyDeviceApp = {
  property: 'Device app type';
  value: 'Web' | 'Tock App (React Native)' | 'Tock App (iOS)';
};
type UserPropertyAuthNetwork = { property: 'Auth network'; value: Network };
type UserPropertyHasGiftCardBalance = { property: 'Has giftcard balance'; value: boolean };
type UserPropertyPatronId = { property: 'PatronId'; value: number };
type UserLandingPage = { property: 'Landing page'; value: string };
type UserLandingPageType = { property: 'Landing page type'; value: PageType };
type UserPropertyExperiments = { property: 'Experiments'; value: string[] };
type UserPropertyBrowser = { property: 'Browser type'; value: string };
type UserPropertyBrowserVersion = { property: 'Browser version'; value: string };
type UserPropertyTockSource = { property: 'Tock source'; value: string };
type UserPropertyTockMedium = { property: 'Tock medium'; value: string };

export type PageType =
  | 'Business'
  | 'Tock'
  | 'Shop Brand'
  | 'Shop'
  | 'Offering detail'
  | 'Checkout'
  | 'Patron account'
  | 'Signup';

export type UserProperty =
  | UserPropertyDeviceApp
  | UserPropertyMetroArea
  | UserPropertyShippingState
  | UserPropertyShopOrders
  | UserPropertyShopOrderedItems
  | UserPropertyShopCentsSpent
  | UserPropertyReservations
  | UserPropertyReservationsCentsSpent
  | UserPropertyAuthNetwork
  | UserPropertyHasGiftCardBalance
  | UserPropertyPatronId
  | UserLandingPage
  | UserLandingPageType
  | UserPropertyExperiments
  | UserPropertyBrowser
  | UserPropertyBrowserVersion
  | UserPropertyTockSource
  | UserPropertyTockMedium;

export type NumericUserProperties = (
  | UserPropertyShopOrders
  | UserPropertyShopOrderedItems
  | UserPropertyShopCentsSpent
  | UserPropertyReservations
  | UserPropertyReservationsCentsSpent
)['property'];

// GA4 todo
